import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import { ModalChiTiet } from "./ModalChiTiet";
export const BtnRuiRoCamDo = ({ item, fromDate, toDate, type }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div>
        <a onClick={handleShow} href={() => false} className="blue btn-link">
          {type === 2 && formatNumber(item.DuNoXau)}
          {type === 3 && formatNumber(item.DuNoRuRo)}
          {type !== 2 && type !== 3 && formatNumber(item.DuNoThuong)}
        </a>
        {show && (
          <ModalChiTiet
            show={show}
            onHide={handleClose}
            fromDate={fromDate}
            toDate={toDate}
            type={type}
          />
        )}
      </div>
    </>
  );
};
